import { render, staticRenderFns } from "./diybasic.vue?vue&type=template&id=c0b8896e&scoped=true&"
import script from "./diybasic.vue?vue&type=script&lang=js&"
export * from "./diybasic.vue?vue&type=script&lang=js&"
import style0 from "./diybasic.vue?vue&type=style&index=0&id=c0b8896e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b8896e",
  null
  
)

export default component.exports